import { Popover, PopoverProps } from 'antd'

export interface KBPopoverProps extends PopoverProps {}

export function KBPopover(props: KBPopoverProps) {
  return <Popover {...props}></Popover>
}
